import { MrNavigationOverlay } from './mr-navigation-overlay';

class MrCtaPanelOverlay extends MrNavigationOverlay {
	override openAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		return [
			new KeyframeEffect(
				this.querySelector( '.modal-dialog__content' ),
				[
					{
						opacity: 0,
					},
					{
						opacity: 1,
					},
				],
				{
					duration: 128,
					easing: 'ease-in-out',
					fill: 'forwards',
				}
			),
			new KeyframeEffect(
				this.querySelector( '.cta-panel' ),
				[
					{
						transform: 'translateX(100%)',
					},
					{
						transform: 'translateX(0)',
					},
				],
				{
					delay: 128,
					duration: 384,
					easing: 'ease-in-out',
					fill: 'forwards',
				}
			),
		];
	}

	override closeAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		return [
			new KeyframeEffect(
				this.querySelector( '.cta-panel' ),
				[
					{
						transform: 'translateX(0)',
					},
					{
						transform: 'translateX(100%)',
					},
				],
				{
					duration: 384,
					easing: 'ease-in-out',
					fill: 'forwards',
				}
			),
			new KeyframeEffect(
				this.querySelector( '.modal-dialog__content' ),
				[
					{
						opacity: 1,
					},
					{
						opacity: 0,
					},
				],
				{
					delay: 256,
					duration: 128,
					easing: 'ease-in-out',
					fill: 'forwards',
				}
			),
		];
	}
}

customElements.define( 'mr-cta-panel-overlay', MrCtaPanelOverlay );
